import axios, { type AxiosError } from 'axios'
import {
    useMutation,
    useQuery,
    useQueryClient,
} from '@tanstack/react-query'
import type {
    CollectionCompany,
    EokoCustomer,
    MutationOptions,
} from '@/types'
import { isErrorResponse } from '@/helpers'

export function useCollectionCompanies() {
    return useQuery({
        queryKey: ['collectionCompanies'],
        queryFn: async () => {
            const { data } : { data: Array<CollectionCompany> } = await axios.get(
                '/api/collection_company/list',
            )
            return data
        },
    })
}



export function useEokoCustomers() {
    return useQuery({
        queryKey: ['eokoCustomers'],
        queryFn: async () => {
            const { data } : { data: Array<EokoCustomer> } = await axios.get(
                '/api/eoko/customer/list',
            )
            return data
        },
    })
}

export const useCreateByEokoCustomer = (options: MutationOptions) => {
    const queryClient = useQueryClient()

    const {
        onSuccessCallback,
        onErrorCallback,
        setRequestInProgress,
    } = options

    return useMutation({
        mutationFn: (selectedId: string) => {            
            const queryParams = new URLSearchParams()
            queryParams.append('eoko_customer_id', selectedId)
            
            return axios.post(`/api/collection_company/create_by_eoko_customer?${queryParams.toString()}`)
        },
        onSuccess: response => {
            queryClient.invalidateQueries({ queryKey: ['collectionCompanies'] })
            if (onSuccessCallback) {
                onSuccessCallback(response.data)
            }
        },
        onSettled: () => {
            setRequestInProgress(false)
        },
        onError: (axiosResponse: AxiosError) => {
            const errorData = axiosResponse.response?.data
            if (onErrorCallback){
                if (isErrorResponse(errorData)) {
                    onErrorCallback(errorData.error)
                } else {
                    console.error(axiosResponse)
                    onErrorCallback('Došlo k neočekávané chybě.');
                }
            }
        }
    })
}
